import { render, staticRenderFns } from "./ImportComponent.vue?vue&type=template&id=489718bd&scoped=true"
import script from "./ImportComponent.vue?vue&type=script&lang=js"
export * from "./ImportComponent.vue?vue&type=script&lang=js"
import style0 from "./ImportComponent.vue?vue&type=style&index=0&id=489718bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489718bd",
  null
  
)

export default component.exports